<pathPantalla></pathPantalla>

<div [hidden]="consulta">
    <!-- Filtros -->
    <div class="row">
        <div class="col-lg-12" style="padding: 0px">
            <section class="widget">
                <!-- título -->
                <header>
                    <h3> {{sistemaService.NombrePantallaActual}} </h3>
                </header>
                <div class="separador"></div>
                <filtros (filtroAplicado)="SetDatos($event)" [filtros]="filtrosDisplay" [urlApi]="uriApi" #filtrosComponent></filtros>
            </section>
        </div>
    </div>

    <div class="divisor8"></div>

    <div class="row">
        <div class="col-lg-12" style="padding: 0px">
            <section class="widget">
                <!-- tabla -->
                <div>

                    <!-- Agregar  -->
                    <div class="row margen">
                        <div class="col-12">
                            <div class="panelBotonesFiltro mixto">
                                <button matTooltip="Agregar" class="btn boton botonXS" (click)="Formulario(1)" *ngIf="sistemaService.permisos.agregar">
                                    <span class="fa fa-plus"></span>
                                    <span> {{'Agregar'}}</span>
                                </button>
                                <div class="divisorH16 "></div>
                                <button matTooltip="Importar" class="btn boton botonXS " (click)="cargarContenedorLayout()"  *ngIf="sistemaService.permisos.agregar">
                                    <span class="fa fa-upload"></span>
                                    <span> {{'Importar layout'}}</span>
                                </button>
                                <div class="divisorH16 "></div>
                                <!-- <button matTooltip="Generar" class="btn boton botonXS " (click)="DescargarLayout()" *ngIf="sistemaService.permisos.agregar">
                                    <span class="fa fa-file-excel-o"></span>
                                    <span> {{'Generar layout'}}</span>
                                </button> -->
                            </div>
                        </div>
                    </div>

                    <div class="divisor16"></div>

                    <!-- datos -->
                    <dx-data-grid
                        (onOptionChanged)="sistemaService.CambiarPaginacionTabla($event)"
                        id="tabla"
                        [columnAutoWidth]="true"
                        [dataSource]="dataTable"
                        [noDataText]="'Sin Datos'"
                        [showColumnHeaders]="true"
                        >
                        <dxo-export [enabled]="true" [fileName]="sistemaService.NombrePantallaActual" matTooltip="Todo" *ngIf="sistemaService.permisos.exportar"></dxo-export>

                        <dxo-search-panel
                            [visible]="true"
                            [width]="240"
                            placeholder="{{'Buscar' | translate}}">
                        </dxo-search-panel>

                        <dxo-paging [pageSize]="sistemaService.tablaPaginacion"></dxo-paging>
                        <!--<dxo-scrolling mode="virtual" [useNative]="false" [showScrollbar]="'always'"></dxo-scrolling>-->

                        <dxo-pager
                            [visible]="true"
                            [allowedPageSizes]="sistemaService.tablaPaginacionPaginaSize"
                            [displayMode]="sistemaService.tablaPaginacionModo"
                            [showPageSizeSelector]="sistemaService.tablaPaginacionSelector"
                            [showInfo]="sistemaService.tablaPaginacionInfo"
                            [showNavigationButtons]="sistemaService.tablaPaginacionNavegacion">
                        </dxo-pager>

                        <dxi-column
                            [allowExporting]="false"
                            caption="Acciones"
                            cellTemplate="cellAcciones"
                            alignment="center"
                            [minWidth]="120">

                        </dxi-column>
                        <dxi-column
                            dataField="competencia"
                            caption="Competencia">
                        </dxi-column>
                        <dxi-column
                            dataField="criterio"
                            caption="Criterio">
                        </dxi-column>
                        <dxi-column
                            dataField="pregunta"
                            caption="Pregunta">
                        </dxi-column>
                        <dxi-column
                        dataField="escalaevaluacion"
                        caption="Escala evaluación">
                    </dxi-column>
                        <dxi-column
                            dataField="nivel"
                            caption="Nivel">
                        </dxi-column>
                        <dxi-column
                            dataField="activo"
                            caption="Activo"
                            cellTemplate="cellActivo"
                            [calculateCellValue]="sistemaService.GetValorActivo"
                            alignment="center">
                        </dxi-column>


                        <!-- Activo -->
                        <div *dxTemplate="let cell of 'cellActivo'" class="iconoActivo">
                            <span *ngIf="cell.data.activo" class="fa fa-check-square-o"></span>
                            <span *ngIf="!cell.data.activo" class="fa fa-square-o"></span>
                        </div>
                        <!-- Acciones -->
                        <div *dxTemplate="let cell of 'cellAcciones'">
                            <a matTooltip="Ver" class="tablaBoton" (click)="Formulario(2, cell.data.preguntaid)">
                                <i class="fa fa-eye fa-lg" aria-hidden="true"></i>
                            </a>
                            <a matTooltip="Editar" class="tablaBoton separado edit" (click)="Formulario(3,cell.data.preguntaid)" [class.disabled]="cell.data.tipopreguntaid == 2 && !sistemaService.permisos.edicionespecial" *ngIf="sistemaService.permisos.editar">
                                <i class="fa fa-pencil fa-lg" aria-hidden="true"></i>
                            </a>
                            <a matTooltip="Eliminar" class="tablaBoton separado delete" (click)="Eliminar(cell.data)" *ngIf="sistemaService.permisos.eliminar">
                                <i class="fa fa-trash fa-lg" aria-hidden="true"></i>
                            </a>
                        </div>

                    </dx-data-grid>

                </div>
            </section>
        </div>
    </div>
</div>
<div #containerFormulario></div>